module.exports = __webpack_public_path__ + "static/img/dusty_g.2e57111f.png";